import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDocumentsTypes } from 'system-redux-sagas/actions';

type TUseDocumentsType = {
  documentsTypes: { id: string; label: string }[];
  loadingDocumentsTypes: boolean;
};

export const useDocumentsType = (fetch: boolean = true): TUseDocumentsType => {
  const lock = useRef<boolean>(false);
  const { documentsTypes, loadingDocumentsTypes } = useSelector(
    (state: any) => state.system,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (!lock.current) {
      lock.current = true;
      fetch && dispatch(getDocumentsTypes());
    }
  }, [dispatch, fetch]);

  return {
    documentsTypes,
    loadingDocumentsTypes,
  };
};
